import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES, isSupportedLanguage } from '@/i18n/languagePreference';

/**
 * The "preferred language" field shared by the profile panel and the two
 * person-edit forms. A free-text value from before this select existed (or
 * from data entered elsewhere) is kept as an extra option rather than
 * silently dropped, so saving the form without touching this field never
 * changes it.
 */
export function PreferredLanguageSelect({
  id,
  value,
  onChange,
}: {
  id?: string;
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation();
  const hasLegacyValue = value !== '' && !isSupportedLanguage(value);

  return (
    <select id={id} value={value} onChange={(event) => onChange(event.target.value)}>
      <option value="">{t('profile.preferredLanguageUnset')}</option>
      {SUPPORTED_LANGUAGES.map((lng) => (
        <option key={lng} value={lng}>
          {t(`common.languages.${lng}`)}
        </option>
      ))}
      {hasLegacyValue && <option value={value}>{value}</option>}
    </select>
  );
}
